import React from 'react';
import { PAGE_TYPES } from '../enums/page-types';

// Stripe.js surfaces internal errors like "Could not retrieve elements store due to
// unexpected error." when the connected account is restricted. Buyers and sellers can't
// act on those, so map them to a message that explains the actual cause.
const RESTRICTED_ACCOUNT_ERROR_PATTERNS = [/elements store/i];

const PAGE_TYPE_NOUNS = {
  [PAGE_TYPES.CHECKOUT]: 'checkout page',
  [PAGE_TYPES.EVENT]: 'event',
  [PAGE_TYPES.FORM]: 'form',
};

export const getRestrictedAccountError = pageType => {
  const noun = PAGE_TYPE_NOUNS[pageType] || PAGE_TYPE_NOUNS[PAGE_TYPES.CHECKOUT];

  return (
    <>
      Payments are unavailable because the seller&apos;s Stripe account is restricted. If this is
      your {noun}, review the required actions in your{' '}
      <a
        href="https://dashboard.stripe.com"
        target="_blank"
        rel="noopener noreferrer"
        className="underline"
      >
        Stripe Dashboard
      </a>
      .
    </>
  );
};

const getUserFacingPaymentError = (message, pageType) => {
  if (typeof message !== 'string') return message;

  if (RESTRICTED_ACCOUNT_ERROR_PATTERNS.some(pattern => pattern.test(message))) {
    return getRestrictedAccountError(pageType);
  }

  return message;
};

export default getUserFacingPaymentError;
